import api from './api';

export interface DashboardStats {
  total_empresas?: number;
  empresas_ativas?: number;
  empresas_com_licenca?: number;
  total_usuarios: number;
  usuarios_ativos: number;
  acessos_hoje: number;
  acessos_mes: number;
}

export interface AcessoRecente {
  user: string;
  action: string;
  module: string | null;
  ip: string | null;
  data: string | null;
}

const adminDashboardService = {
  async stats(): Promise<DashboardStats> {
    const response = await api.get<DashboardStats>('/admin-dashboard');
    return response.data;
  },
  async acessosRecentes(): Promise<AcessoRecente[]> {
    const response = await api.get<AcessoRecente[]>('/admin-dashboard/acessos_recentes');
    return response.data;
  },
};

export default adminDashboardService;
